import { jsx as _jsx } from "react/jsx-runtime";
import MainSection from 'marketplace-ui-common/layout/components/MainSection';
import styled from 'styled-components';
export const HOME_SECTION_Y_PADDING = 84;
const HomeSection = styled(props => /*#__PURE__*/_jsx(MainSection, Object.assign({}, props, {
  responsive: true
}))).withConfig({
  displayName: "HomeSection",
  componentId: "u4hlwh-0"
})(["padding-top:", "px;padding-bottom:", "px;font-size:16px;line-height:28px;display:flex;flex-direction:column;align-items:center;"], HOME_SECTION_Y_PADDING, HOME_SECTION_Y_PADDING);
export default HomeSection;